<div class="flex-header">
  <div class="mat-dialog-title">Email Your Username</div>
</div>
<div class="flex-content">
  <form [formGroup]="forgotUserNameForm" id="ForgotUsernameForm" *ngIf="!(forgotUserName.isEmailSent)">
    <div>
      <p>
        If the information you provide below matches exactly with our records, an email will be sent with your user
        name.
      </p>
    </div>
    <tyl-form-field [errorMessage]="firstNameError" label="First Name" style="width: 100%">
      <input matInput style="width:200px;" maxlength="100"
             id="firstNameField"
             name="First Name"
             formControlName="firstName"
             aria-label="First Name" required/>
    </tyl-form-field>
    <br/>
    <tyl-form-field [errorMessage]="lastNameError" label="Last Name" style="width: 100%">
      <input matInput style="width:200px;" maxlength="100"
             id="lastNameField"
             name="Last Name"
             formControlName="lastName"
             aria-label="Last Name" required/>
    </tyl-form-field>
    <br/>
    <tyl-form-field [errorMessage]="emailAddressError" label="Email Address" style="width: 100%">
      <input matInput style="width:350px;" maxlength="100"
             id="emailAddressInput"
             name="Email Address"
             formControlName="emailAddress"
             aria-label="Email Address" required/>
    </tyl-form-field>
    <table>
      <tr *ngIf="duplicateRecords">
        <td style="padding-top:10px;padding-bottom: 10px; color:red;">
          Multiple accounts were found matching this information. Please contact the {{LoginSettings.CountryCode ==
          'CAN' ? 'division'
          : 'district'}} for assistance{{LoginSettings.ShowLoginAssistanceInfo ? ': ' : '.'}}
          <span *ngIf="LoginSettings.ShowLoginAssistanceInfo">
            <span *ngIf="LoginSettings.UsernamePasswordRequestEmail != ''">{{LoginSettings.UsernamePasswordRequestEmail}}</span>
            <span
              *ngIf="LoginSettings.UsernamePasswordRequestEmail != '' && LoginSettings.UsernamePasswordRequestPhone != ''"> or </span>
            <span *ngIf="LoginSettings.UsernamePasswordRequestPhone != ''">({{LoginSettings.UsernamePasswordRequestPhone.substring(0,3)}}) {{LoginSettings.UsernamePasswordRequestPhone.substring(3,6)}}-{{LoginSettings.UsernamePasswordRequestPhone.substring(6)}}</span>
          </span>
        </td>
      </tr>
    </table>
  </form>
</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="save.png" label="Continue" (clickEvent)="modalInstanceContinueClick()"
                *ngIf="!(forgotUserName.isEmailSent)"></tyl-button>
    <tyl-button image="Cancel.png" label="{{forgotUserName.isEmailSent ? 'Close' : 'Cancel'}}"
                (clickEvent)="modalInstanceCancelClick()"></tyl-button>
  </div>
</div>

